import { memo } from "react";
import { useThemeLayout } from "contexts/store";
import AddToCartBase from "./Base";
import AddToCartCustom1 from "./Custom1";
import useAddToCartViewModel from "./useAddToCartViewModel";

const AddToCart = () => {
    const themeLayout = String(useThemeLayout() || "base").toLowerCase();
    const viewModel = useAddToCartViewModel();
    const Layout = themeLayout === "custom1" ? AddToCartCustom1 : AddToCartBase;
    return <Layout viewModel={viewModel} />;
};

export default memo(AddToCart);
